// node_modules
import { FC, MouseEvent, useContext } from "react";
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// styles
import styles from "./tileSidebarMenu.module.scss";
// Contexts
import { DeliveryLayoutContext } from "Providers";

type TTileSidebarMenu = {
    children: (JSX.Element | null)[];
}

export const TileSidebarMenu: FC<TTileSidebarMenu> = ({ children }: TTileSidebarMenu) => {
    // Contexts
    const { 
        isCommentTileOpen, 
        isRightSidebarCollapsed, 
        setIsRightSidebarCollapsed,
        isOnRightSidebarHoverCollapsed,
        setIsOnRightSidebarHoverCollapsed
    } = useContext(DeliveryLayoutContext);

    const getTileSidebarClassName = (): string => {
        let classNameList = [styles.tileSidebarMenuContainer, styles.scrollbarCustomThin];
        if(isCommentTileOpen) classNameList.push(styles.commentTileIsOpen);
        if(isRightSidebarCollapsed) classNameList.push(styles.tileSidebarMenuCollapsed);
        return classNameList.join(" "); 
    }

    const getCollapseClassName = (): string => {
        let classNameList = [styles.collapseOrUncollapseRightSidebar];
        if(isRightSidebarCollapsed) classNameList.push(styles.uncollapseRightSidebarMenu);                  
        return classNameList.join(" ");
    };

    const handleOnAndOffHoverCollapsedSidebarRight = (mouseEvent: MouseEvent): void => {
        if (isRightSidebarCollapsed) {
            setIsOnRightSidebarHoverCollapsed(!isOnRightSidebarHoverCollapsed);
        } else {
            return;
        }
    }

    function handleOnClickSetIsCollapsedSidebarRight() {
        setIsRightSidebarCollapsed(!isRightSidebarCollapsed);
        setIsOnRightSidebarHoverCollapsed(!isOnRightSidebarHoverCollapsed);
    }

    return (
        <div className={getTileSidebarClassName()}
        onMouseEnter={handleOnAndOffHoverCollapsedSidebarRight} 
        onMouseLeave={handleOnAndOffHoverCollapsedSidebarRight} >
            <div onClick={handleOnClickSetIsCollapsedSidebarRight} className={getCollapseClassName()}>
                {isRightSidebarCollapsed ?
                    <FontAwesomeIcon icon={faChevronLeft} />
                    :
                    <FontAwesomeIcon icon={faChevronRight} />
                }
            </div>
            {children}
        </div>
    );
}